<template>
    <div class="mb-2 col-md-6" v-if="isVisible">
        <el-input
            :value="pending"
            :clearable="clearable"
            :placeholder="placeholder"
            @input="onChange"
        ></el-input>
    </div>
</template>

<script>
    import BaseFilter from "./base-filter";

    export default {
        extends: BaseFilter,
    }
</script>
